

interface IProps {
    onClick?: () => void;
    size?: number
}

export const RightArrow = (props: IProps) => {
    const { onClick, size } = props;

    return (
        <svg width={size || "8"} height={size || "13"} onClick={onClick} viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.969637 0.969671C0.676788 1.26257 0.676788 1.73744 0.969638 2.03033L5.43934 6.5L0.969638 10.9697C0.676788 11.2626 0.676788 11.7375 0.969638 12.0304C1.26254 12.3232 1.73744 12.3232 2.03034 12.0304L7.03034 7.03035C7.32319 6.73745 7.32319 6.26255 7.03034 5.96965L2.03034 0.969671C1.73744 0.676776 1.26254 0.676776 0.969637 0.969671Z" fill="black" />
        </svg>
    );
};
